import { Employee } from "@models/employee";
import { Injectable } from "@angular/core";
import { AbstractClass, TableCell } from "@classes/abstract.class";
@Injectable({providedIn: 'root'})
export class EmployeeClass extends AbstractClass {
  model: Employee;
  modelName = 'Employies';
  idName = 'employeeID';
  langBase = 'cms.components.employee.';
  route = 'cms/user/employee';
  tableCells: TableCell[] = [
    { name: 'autoincrement', label: 'autoincrement', cellType: 'autoincrement', order: true, download: true }, // reserved word to insert the count
    { name: 'tenant.tenantName', label: 'tenant', cellType: 'text', order: true, download: true },
    { name: 'user.email', label: 'email', cellType: 'text', order: true, download: true },
    { name: 'name', label: 'name', cellType: 'text', order: true, download: true },
    { name: 'lastName', label: 'lastName', cellType: 'text', order: true, download: true },
    { name: 'documentType.type', label: 'documentType', cellType: 'text', order: true, download: true },
    { name: 'document', label: 'document', cellType: 'number', order: true, download: true },
    { name: 'employeeNumber', label: 'employeeNumber', cellType: 'number', order: true, download: true },
    { name: 'telephone', label: 'telephone', cellType: 'number', order: true, download: true },
    { name: 'gender', label: 'gender', cellType: 'text', order: true, download: true },
    { name: 'user.roleGroup.roleGroupName', label: 'role', cellType: 'text', order: true, download: true },
    { name: 'hiringCompany.companyName', label: 'hiringCompany', cellType: 'text', order: true, download: true },
    { name: 'hiringDate', label: 'hiringDate', cellType: 'date', order: true, download: true },
    { name: 'user.isActive', label: 'isActive', cellType: 'active-text', order: true, download: true },
    { name: 'createdAt', label: 'createdAt', cellType: 'date', order: true, download: true },
    //{ name: 'siteLocation.city.countryZone.zoneName', label: 'countryZone', cellType: 'text', order: true },
    //{ name: 'siteLocation.city.cityName', label: 'city', cellType: 'text', order: true },
  ];
  formAccordion = [];
  formTabs = [
    /* {
      name: 'tab1',
      formCells: [
        { name: 'gender', label: 'gender', cellType: 'genderList', disable: false, order: 1, cols: 'col-12 col-md-6', required: true, type: 'string' },
        { name: 'birthdate', label: 'birthdate', cellType: 'date', disable: false, order: 6, cols: 'col-12 col-md-6', required: true, type: 'date' },
        { name: 'name', label: 'fullName', cellType: 'text', disable: false, order: 3, cols: 'col-12 col-md-6', required: true, type: 'string' },
        //{ name: 'lastName', label: 'lastName', cellType: 'text', disable: false, order: 5, cols: 'col-12 col-md-6', required: true },
        { name: 'documentTypeID', label: 'documentType', cellType: 'documentTypeID', disable: false, order: 2, cols: 'col-12 col-md-6', required: true, type: 'number' },
        { name: 'document', label: 'document', cellType: 'text', disable: false, order: 4, cols: 'col-12 col-md-6', required: true, type: 'number' },
        { name: 'email', label: 'email', cellType: 'text', disable: false, order: 7, cols: 'col-12 col-md-6', required: true, type: 'number' },
        { name: 'telephone', label: 'telephone', cellType: 'text', disable: false, order: 8, cols: 'col-12 col-md-6', required: true, type: 'number' },
        { name: 'photo', label: 'photo', cellType: 'image', disable: false, order: 9, cols: 'col-12 col-md-6', required: false, type: 'number' },
        { name: 'password', label: 'password', cellType: 'password', disable: false, order: 9, cols: 'col-12 col-md-6', required: false, type: 'number' },
      ]
    },
    {
      name: 'tab2',
      formCells: [
        { name: 'roleGroupID', label: 'userRol', cellType: 'roleGroupID', disable: false, order: 1, cols: 'col-12 col-md-6', required: true },
        { name: 'employeeNumber', label: 'employeeNumber', cellType: 'text', disable: false, order: 1, cols: 'col-12 col-md-6', required: true },
        { name: 'categoryGroupID', label: 'categoryGroup', cellType: 'categoryGroupID', disable: false, order: 1, cols: 'col-12 col-md-6', required: true },
        { name: 'countryListID', label: 'countryList', cellType: 'countryList', disable: false, order: 3, cols: 'col-12 col-md-6', required: true },
        { name: 'cityID', label: 'city', cellType: 'cityByCountry', disable: false, order: 4, cols: 'col-12 col-md-6', required: true },
        { name: 'siteStores', label: 'siteStore', cellType: 'trainingChain', disable: false, order: 5, cols: 'col-12 col-md-6', required: true },
        { name: 'siteLocations', label: 'siteLocation', cellType: 'shopMultiple', disable: false, order: 6, cols: 'col-12 col-md-6', required: true },
      ]
    },
    {
      name: 'tab3',
      formCells: [
        { name: 'hiringCompanyID', label: 'hiringCompany', cellType: 'hiringCompanyID', disable: false, order: 1, cols: 'col-12 col-md-6', required: true },
        { name: 'hiringDate', label: 'hiringDate', cellType: 'date', disable: false, order: 2, cols: 'col-12 col-md-6', required: true },
        { name: 'isActive', label: 'isActive', cellType: 'active', disable: false, order: 7, cols: 'col-12 col-md-6', required: false },
      ]
    } */
  ];
  formCells = [
    { name: 'tenantID', label: 'tenant', cellType: 'tenant', disable: false, order: 0, cols: 'col-12', required: false, multiple: false, type: 'string' },
    { name: 'name', label: 'name', cellType: 'text', disable: false, order: 1, cols: 'col-12 col-md-6', required: true, multiple: false, type: 'string' },
    { name: 'lastName', label: 'lastName', cellType: 'text', disable: false, order: 2, cols: 'col-12 col-md-6', required: true, multiple: false, type: 'string' },
    { name: 'documentTypeID', label: 'documentType', cellType: 'documentType', disable: false, order: 3, cols: 'col-12 col-md-6', required: true, multiple: false, type: 'number' },
    { name: 'document', label: 'document', cellType: 'text', disable: false, order: 4, cols: 'col-12 col-md-6', required: true, multiple: false, type: 'number' },
    { name: 'employeeNumber', label: 'employeeNumber', cellType: 'text', disable: false, order: 5, cols: 'col-12 col-md-6', required: true, multiple: false, type: 'number' },
    { name: 'telephone', label: 'telephone', cellType: 'text', disable: false, order: 6, cols: 'col-12 col-md-6', required: true, multiple: false, type: 'number' },
    { name: 'gender', label: 'gender', cellType: 'gender', disable: false, order: 7, cols: 'col-12 col-md-6', required: true, multiple: false, type: 'string' },
    { name: 'birthdate', label: 'birthdate', cellType: 'date', disable: false, order: 8, cols: 'col-12 col-md-6', required: true, multiple: false, type: 'date' },
    { name: 'hiringCompanyID', label: 'hiringCompany', cellType: 'hiringCompany', disable: false, order: 9, cols: 'col-12 col-md-6', required: true, multiple: false, type: 'number' },
    { name: 'hiringDate', label: 'hiringDate', cellType: 'date', disable: false, order: 10, cols: 'col-12 col-md-6', required: false, multiple: false, type: 'date' },
    { name: 'photo', label: 'photo', cellType: 'image', disable: false, order: 11, cols: 'col-12 col-md-6', required: false, multiple: false, type: 'file' },
    { name: 'roleGroupID', label: 'rolGroup', cellType: 'rolGroup', disable: false, order: 11, cols: 'col-12 col-md-6', required: false, multiple: false, type: 'number' },
    { name: 'isActive', label: 'isActive', cellType: 'checkbox', disable: false, order: 12, cols: 'col-12 col-md-6', required: false, multiple: false, type: 'number' },
    { name: 'email', label: 'email', cellType: 'email', disable: false, order: 13, cols: 'col-12 col-md-6', required: true, multiple: false, type: 'string' },
    { name: 'password', label: 'password', cellType: 'password', disable: false, order: 14, cols: 'col-12 col-md-6', required: false, multiple: false, type: 'string' }
];
  modelCells = [];
  tabs = [];

  constructor()
  {
    super();
    this.stringsToRemove = ['userID']
    this.model = {
      employeeID: 0,
      tenantID: 0,
      roleGroupID: 0,
      userID:	0,
      departmentGroupID: 1,
      countryID: 1,
      documentTypeID:	0,
      hiringCompanyID: 0,
      name:	'',
      lastName:	'',
      fullName:	'',
      document: '',
      gender:	'',
      telephone:	'',
      personalQR: '',
      photo: '',
      employeeNumber: '',
      isActive: false,
      birthdate: new Date(),
      hiringDate: new Date(),
      points: 0,
      pointsChanged: 0,
      pointsOverdue: 0,
      expirationDate: new Date(),
      createdAt: new Date(),
      updatedAt: new Date(),
      deletedAt: null,
      createdBy: '',
      user: null,
      tenant: null
    };
  }
}

import {User} from "@models/user";
